import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Entry';
import reportWebVitals from './reportWebVitals';
import CSPMeta from './CSPMeta';
import { Provider } from "react-redux";
import store from './shared/redux/store';
import "antd/dist/reset.css";
 
ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
    <CSPMeta/>
      <App />
    </Provider>,
  //  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
